import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Typography,
} from "@material-ui/core"
import { People } from "@material-ui/icons"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom/cjs/react-router-dom"
import { changeRol } from "src/redux/slices/authSlice"
import { resetTheme } from "src/redux/slices/themeSlice"
import { Roles, basePaths } from "src/utils/Constants"
import { useAccountMenuStyles } from "./accountMenuStyles"

const ROLE_ORDER = [
  Roles.superadmin,
  Roles.admin,
  Roles.directiva,
  Roles.supervisor,
  Roles.parkey,
]

const sortRoles = roles => {
  const availableRoles = Object.keys(roles).filter(
    item => roles[item] && basePaths[item]
  )

  return availableRoles.sort((a, b) => {
    const indexA = ROLE_ORDER.indexOf(a)
    const indexB = ROLE_ORDER.indexOf(b)
    const orderA = indexA === -1 ? ROLE_ORDER.length : indexA
    const orderB = indexB === -1 ? ROLE_ORDER.length : indexB

    if (orderA !== orderB) return orderA - orderB
    return a.localeCompare(b)
  })
}

const RolesSelector = ({ rol, roles }) => {
  const classes = useAccountMenuStyles()
  const arrRoles = sortRoles(roles)
  const dispatch = useDispatch()
  const history = useHistory()
  const [open, setOpen] = useState(false)

  const handleToggle = () => setOpen(prev => !prev)

  const handleSelector = newrol => {
    if (newrol === "supervisor") {
      newrol = Roles.supervisor
    }
    dispatch(resetTheme())
    dispatch(changeRol(newrol))
    history.replace(basePaths[newrol])
    handleToggle()
  }

  if (arrRoles.length <= 1) return null

  return (
    <Box className={classes.section}>
      <MenuItem
        divider={false}
        onClick={handleToggle}
        className={classes.menuItemLevel1}
      >
        <Box
          display="flex"
          alignItems="center"
          width="100%"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" minWidth={0} flex={1}>
            <People className={classes.menuItemIcon} />
            <Box minWidth={0}>
              <Typography className={classes.menuItemSublabel}>
                Rol activo
              </Typography>
              <Typography className={classes.menuItemValue} noWrap>
                {rol}
              </Typography>
            </Box>
          </Box>
          {open ? (
            <ExpandLessIcon fontSize="small" className={classes.expandIcon} />
          ) : (
            <ExpandMoreIcon fontSize="small" className={classes.expandIcon} />
          )}
        </Box>
      </MenuItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          dense
          className={classes.nestedList}
        >
          {arrRoles.map(item => (
            <ListItem
              key={item}
              button
              dense
              selected={item === rol}
              className={`${classes.nestedItem} ${item === rol ? classes.selectedItem : ""}`}
              onClick={() => handleSelector(item)}
            >
              <ListItemText
                className={classes.nestedItemText}
                primary={item}
                primaryTypographyProps={{
                  className: classes.nestedItemLabel,
                  variant: "body2",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box>
  )
}

export default RolesSelector
